/**
 * @purpose: Surat Jalan Detail modal controller - display comprehensive SJ information
 * @called_by: manifest.bagging.delivery.ctrl.js via modalFactory.open()
 * @deps: AngularJS app, urlServices, toaster, $uibModalInstance, params
 * @public: modalSuratJalanDetailCtrl
 * @side_effects: loads surat jalan detail from API and displays in modal
 */
app.controller('modalSuratJalanDetailCtrl', ['$scope', '$uibModalInstance', 'urlServices', 'toaster', 'params',
    function($scope, $uibModalInstance, urlServices, toaster, params) {

    // Initialize scope
    $scope.sjId = params && params.sjId ? params.sjId : '';
    $scope.loading = true;
    $scope.error = null;
    $scope.header = null;
    $scope.detail = [];
    $scope.baggings = [];

    /**
     * Load surat jalan detail from API
     */
    $scope.loadDetail = function() {
        if (!$scope.sjId) {
            $scope.loading = false;
            $scope.error = 'Nomor Surat Jalan tidak ditemukan';
            return;
        }

        $scope.loading = true;
        $scope.error = null;

        urlServices.ambilData('api/bagging-sj/' + encodeURIComponent($scope.sjId), {}, function(err, result) {
            $scope.loading = false;

            if (err) {
                $scope.error = typeof err === 'string' ? err : (err.err || err.message || 'Gagal memuat detail surat jalan');
                toaster.pop('error', 'Error', $scope.error);
                return;
            }

            if (!result) {
                $scope.error = 'Data Surat Jalan tidak ditemukan';
                return;
            }

            $scope.header = result;
            $scope.detail = result.detail || [];
            $scope.baggings = result.baggings || [];
        });
    };

    /**
     * Close modal
     */
    $scope.close = function() {
        $uibModalInstance.dismiss('cancel');
    };

    // Load data on initialization
    $scope.loadDetail();
}]);
